
export default {
    props: {
        content: String,
        userName: String,
        userPosition: String,
        userPic: String
    },
}
